import { Component, OnInit, Input } from '@angular/core';
import { alertesLibelle } from '../../questionnaire.metadata';
import { AlertesService } from '../../alertes.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-affiche-alertes',
  templateUrl: './affiche-alertes.component.html',
  styleUrls: ['./affiche-alertes.component.css']
})
export class AfficheAlertesComponent implements OnInit {
  @Input()
  labelAlerte: string;
  @Input()
  colorErreur: string = 'warning';
  /** labelMessage vaut labelAlerte sauf pour les boucles */
  private labelMessage: string = '';
  constructor(
    public alertesService: AlertesService,
    public modeRendu: ModeRenduService
  ) {

  }
  ngOnInit(): void {
    if (this.labelAlerte.includes('_')) {
      this.labelMessage = this.labelAlerte.substring(0, this.labelAlerte.indexOf('_'));
    } else {
      this.labelMessage = this.labelAlerte;
    }
  }


  public get libelle(): string {
    return alertesLibelle.get(this.labelMessage);
  }


}

